const ActiveBadge = () => {
  return (
    <div className="flex items-center gap-1 rounded-full border border-brand bg-transparent px-2 py-1 text-xs font-medium text-brand-primary">
      <div className="h-2 w-2 rounded-full bg-brand-primary"></div>
      Active
    </div>
  );
};

export default ActiveBadge;
